// src/components/Profile/PasswordUpdateForm.js

import React, { useState } from 'react'
import {
  Typography,
  Grid,
  TextField,
  Button,
  CircularProgress
} from '@mui/material'
import { auth } from '../../firebase'
import { 
  updatePassword, 
  reauthenticateWithCredential, 
  EmailAuthProvider 
} from 'firebase/auth'

// Çoklu dil desteği
import { useTranslation } from 'react-i18next'

export default function PasswordUpdateForm({ setError, setSuccess }) {
  const { t } = useTranslation() // i18n Hook

  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmNewPassword, setConfirmNewPassword] = useState('')
  const [passwordUpdating, setPasswordUpdating] = useState(false)

  const handlePasswordUpdate = async (e) => {
    e.preventDefault()
    setPasswordUpdating(true)
    setError('')
    setSuccess('')

    if (newPassword !== confirmNewPassword) {
      setError(t('passwordUpdateForm.mismatchError')) 
      setPasswordUpdating(false)
      return
    }

    try {
      const user = auth.currentUser
      const credential = EmailAuthProvider.credential(user.email, currentPassword)
      // Kullanıcının kimliğini yeniden doğrulama
      await reauthenticateWithCredential(user, credential)
      // Şifreyi güncelle
      await updatePassword(user, newPassword)

      setSuccess(t('passwordUpdateForm.updateSuccess'))
      // Alanları temizleme
      setCurrentPassword('')
      setNewPassword('')
      setConfirmNewPassword('')
    } catch (err) {
      console.error('Şifre güncellenirken hata:', err)
      if (err.code === 'auth/wrong-password') {
        setError(t('passwordUpdateForm.wrongPasswordError'))
      } else if (err.code === 'auth/weak-password') {
        setError(t('passwordUpdateForm.weakPasswordError'))
      } else {
        setError(t('passwordUpdateForm.genericError'))
      }
    } finally {
      setPasswordUpdating(false)
    }
  }

  return (
    <form onSubmit={handlePasswordUpdate}>
      <Typography variant="h5" gutterBottom>
        {t('passwordUpdateForm.title')}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={t('passwordUpdateForm.currentPasswordLabel')}
            type="password"
            variant="outlined"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            required
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={t('passwordUpdateForm.newPasswordLabel')}
            type="password"
            variant="outlined"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            helperText={t('passwordUpdateForm.newPasswordHelper')}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={t('passwordUpdateForm.confirmNewPasswordLabel')}
            type="password"
            variant="outlined"
            value={confirmNewPassword}
            onChange={(e) => setConfirmNewPassword(e.target.value)}
            required
          />
        </Grid>
      </Grid>

      <Button
        type="submit"
        variant="contained"
        color="secondary"
        fullWidth
        sx={{ mt: 2, py: 1.5 }}
        disabled={passwordUpdating}
      >
        {passwordUpdating 
          ? <CircularProgress size={24} color="inherit" /> 
          : t('passwordUpdateForm.submitButton')
        }
      </Button>
    </form>
  )
}